import { all, fork } from 'redux-saga/effects'
import directory from './directory-saga'
import employeeLog from './employee-log-saga'
import screeningLog from './screening-log-saga'

export default function* employees() {
  yield all([fork(directory), fork(employeeLog), fork(screeningLog)])
}
